'use strict'

module.exports =
  omitUndefined: (obj) ->
    filteredObj = {}
    for key, value of obj
      filteredObj[key] = value if value?
    filteredObj

  capitalize: (str) ->
    str.charAt(0).toUpperCase() + str.substring(1)

  deQuotify: (str) ->
    return unless str?
    str.replace(/&quot;/g, '"')

  getDecodedParam: (param) ->
    return null unless param
    try
      decodeURIComponent param
    catch
      null

